module.exports = __webpack_public_path__ + "19406f7.ttf";